
import 'react-circular-progressbar/dist/styles.css';
import ProgressBar from "react-bootstrap/esm/ProgressBar";
import { IServieTarget } from '../../types/service_target';
function BottomParProgressbarComponent({...props }) {


 

var service: IServieTarget=props.service;
  return (
    <div className="progress-inner">
                                    <div className="row g-0">
                                        <div className="col-xl-2 col-sm-3">
                                            <div className="item040">
                                                <h6> <strong>{service.Title}</strong> <img src="/static/img/men.png" alt="img" className="img-fluid"/ > <span>{service.Reserved}</span></h6>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-sm-7">
                                            <div className="progressx">
                                            <ProgressBar  animated now={service.Progress}></ProgressBar>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="itemEnd">
                                                <p className="mb-0">{service.Allocared}</p>
                                            </div>
                                        </div>


                                    </div>
                                </div>
  );
}

export default BottomParProgressbarComponent;


